import { OpenInNew, Warning } from '@mui/icons-material';
import { Button, Grid, Typography } from '@mui/material';
import { GenConfirmationDialog } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';
import { WOErrorTokens } from '../../../../common/enums/enums';
import { getShortOrderNumber } from '../../../../helpers/orders';

export default function NewOrderDuplicatedError({
  error,
  onEditOrder,
  onDiscard,
}) {
  const { t } = useTranslation(['orders', 'global']);

  return (
    <GenConfirmationDialog
      open={error?.token === WOErrorTokens.DUPLICATED}
      onRefuse={onEditOrder}
      onConfirm={onDiscard}
      title={t('newOrder.errorDuplicatedTitle')}
      titleIconColor={'warning'}
      closeText={t('newOrder.editOrder')}
      confirmText={t('newOrder.discardOrder')}
      titleIcon={Warning}
    >
      <Grid container alignItems="center" justifyContent={'center'}>
        <Grid item textAlign="center">
          <Typography variant="Body1">
            {t('newOrder.errorMessageDuplicated')}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="overline">{t('workOrderNumber')}:</Typography>
          <Button
            endIcon={<OpenInNew />}
            href={`/orders/${error?.data?.vendorOrderId}`}
            target="_blank"
          >
            {getShortOrderNumber(error?.data?.woNumber)}
          </Button>
        </Grid>
      </Grid>
    </GenConfirmationDialog>
  );
}
